import { API_GET_ASPEN_DB_LOGS } from "../ApiConstants";
import axios from "../client/rest";

class ErrorApi {
  static sharedInstance = new ErrorApi();

  constructor() {
    if (ErrorApi.sharedInstance !== null) {
      return ErrorApi.sharedInstance;
    }
  }

  async getAspenDbLog() {
    try {
      const res = await axios.get(API_GET_ASPEN_DB_LOGS);
      if (res.status === 200) {
        const { data } = res;
        return data;
      } else {
        throw "Something went wrong";
      }
    } catch (err) {
      throw err;
    }
  }
}

export default ErrorApi.sharedInstance;
